import React from "react";
import { twMerge } from "tailwind-merge";
import { Skeleton } from "@components/Skeleton/Skeleton";

interface ITabsSkeletonProps {
  className?: string;
  title?: string;
  withIcon?: boolean;
}

export const ButtonSkeleton: React.FC<ITabsSkeletonProps> = ({
  className,
  title,
  withIcon,
}) => (
  <Skeleton variant="rounded" className={twMerge("w-auto", className)}>
    <div className={twMerge("invisible px-4 text-sm", withIcon && "pl-11")}>
      {title}
    </div>
  </Skeleton>
);
